import React, { useEffect, useRef, useState } from "react";
import { googleAds } from "appConfig";
import styles from "./adList.scss"
import GoogleAd from "../GoogleAd";
import { useSelector } from "react-redux";
import { selectProfileLoading, selectUserInfo } from "../../routes/Auth/auth.ducks";

const PLACEHOLDER_HEIGHT = 250
const SINGLE_AD_FALLBACK_DELAY = 3000

export const TwoGoogleAds = ({ index }) => {
  const [loadedAdCount, setLoadedAdCount] = useState(0)
  const [fallbackElapsed, setFallbackElapsed] = useState(false)
  const [contentHeight, setContentHeight] = useState(PLACEHOLDER_HEIGHT)
  const loadedAdIds = useRef(new Set())
  const contentRef = useRef(null)

  const adLoadCallback = (adId) => {
    if (loadedAdIds.current.has(adId)) {
      return;
    }
    loadedAdIds.current.add(adId)
    setLoadedAdCount(loadedAdIds.current.size)
  }

  useEffect(() => {
    const timer = setTimeout(() => setFallbackElapsed(true), SINGLE_AD_FALLBACK_DELAY);

    return () => clearTimeout(timer);
  }, [])

  const userInfo = useSelector(selectUserInfo);
  const profileLoading = useSelector(selectProfileLoading);

  const userHasIndexPremium = userInfo && userInfo.hasIndexPremium;

  // Both ads reveal together so the row never renders half-filled. After the
  // fallback delay a lone ad is shown rather than waiting on a slot that may
  // never fill.
  const showAds = loadedAdCount >= 2 || (fallbackElapsed && loadedAdCount >= 1);

  // When only a single ad fills, center it instead of leaving it off to one side.
  const isSingleAd = showAds && loadedAdCount < 2;

  const box1Id = `googleAds.searchResult.box1-${index}`;
  const box2Id = `googleAds.searchResult.box2-${index}`;

  // In single-ad mode the unfilled slot still occupies a sliver of width and
  // nudges the visible ad off-center, so drop it from layout entirely.
  const box1Hidden = isSingleAd && !loadedAdIds.current.has(box1Id);
  const box2Hidden = isSingleAd && !loadedAdIds.current.has(box2Id);

  useEffect(() => {
    if (!showAds || !contentRef.current) {
      return;
    }

    // GPT sizes the ad iframes asynchronously after slotRenderEnded, so keep the
    // wrapper height synced to the row's real height. Each update animates via
    // the CSS `transition: height`, growing smoothly from the placeholder.
    const syncHeight = () => {
      if (contentRef.current && contentRef.current.scrollHeight > 0) {
        setContentHeight(contentRef.current.scrollHeight);

      }
    };

    syncHeight();

    //@ts-ignore
    if (typeof ResizeObserver === "undefined") {
      return;
    }

    //@ts-ignore
    const observer = new ResizeObserver(syncHeight);
    observer.observe(contentRef.current);

    return () => observer.disconnect();
  }, [showAds])

  if (profileLoading || userHasIndexPremium) {
    return null;
  }

  return (

    <div
      className={`${styles.ads} ${showAds ? styles.adsVisible : ""}`}
      style={{ height: showAds ? contentHeight : PLACEHOLDER_HEIGHT }}
    >
      <div className={`${styles.adsRow} ${isSingleAd ? styles.adsRowSingle : ""}`} ref={contentRef}>
        <GoogleAd
          className={`${styles.adsChild} ${box1Hidden ? styles.adsChildHidden : ""}`}
          adLoadCallback={adLoadCallback}
          config={{
            ...googleAds.searchResult.boxLeft,
            id: box1Id
          }}
        />
        <GoogleAd
          className={`${styles.adsChild} ${box2Hidden ? styles.adsChildHidden : ""}`}
          adLoadCallback={adLoadCallback}
          config={{
            ...googleAds.searchResult.boxRight,
            id: box2Id
          }}
        />
      </div>

      <div
        className={styles.placeholder}
        style={{ minHeight: PLACEHOLDER_HEIGHT }}
      >
        <div style={{ minHeight: PLACEHOLDER_HEIGHT }}>
          <span>OGLAS</span>
        </div>
      </div>
    </div>

  )
}



// WEBPACK FOOTER //
// ./src/components/AdList/TwoGoogleAds.tsx